import { createContext } from "react";

const AppContext = createContext({
  singleConsulting: {},
  setSingleConsulting: () => {},
});

export default AppContext;
